<template>
  <!-- 描述 -->
  <div class="wiki-detail-desc">
    <div class="desc-box">
      <!-- 时间 -->
      <span v-if="detail && detail.updated_at" class="yds-num mR8">
        更新时间：<time :datetime="$dayjs.unix(detail.updated_at).toJSON()" :title="$dayjs.unix(detail.updated_at)">{{
          formatTime(detail.updated_at)
        }}</time>
      </span>

      <!-- 阅读数 -->
      <span class="yds-num"> {{ $t("views") }}：{{ detail ? formatCount(detail.view_count) : "" }} </span>

      <!-- 历史记录版本回滚 -->
      <template v-if="canRollback">
        <div class="wiki-detail-desc">
          <el-button size="mini" type="link" @click="onRollBack">{{ $t("roll_back_to_the_version") }} </el-button>
        </div>
      </template>
      <!-- 编辑文章 -->
      <template v-else>
        <el-dropdown
          v-if="hasBtnPermission(['detail_manage_edit', 'detail_manage_del'])"
          class="right-drop-btn"
          placement="bottom"
          trigger="click"
          @command="onCommand"
        >
          <span>{{ $t("edit") }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="hasBtnPermission('detail_manage_edit')" command="goEdit">
              编辑文章
            </el-dropdown-item>
            <el-dropdown-item
              v-if="detail.entry_id > 0 && $hasPermission('detail_bind_content')"
              command="onShowBindDialog"
            >
              更换文章绑定
            </el-dropdown-item>
            <el-dropdown-item v-if="$hasPermission('content_top')" command="onContentSetTop">
              {{ detail.is_top == 1 ? "取消置顶" : "文章置顶" }}
            </el-dropdown-item>
            <el-dropdown-item v-if="loginUser.is_super == 1" command="onDownHot">
              下热门
            </el-dropdown-item>
            <el-dropdown-item v-if="loginUser.is_super == 1" command="onDisabledComment">
              {{ detail.is_prohibit_reply ? "恢复评论" : "禁止评论" }}
            </el-dropdown-item>
            <el-dropdown-item v-if="hasBtnPermission('detail_manage_del')" command="onChangeAuthor">
              更换作者
            </el-dropdown-item>
            <el-dropdown-item v-if="hasBtnPermission('detail_manage_del')" command="setChangeRaiders">
              {{ detail.is_strategy ? "取消攻略" : "设为攻略" }}
            </el-dropdown-item>
            <el-dropdown-item v-if="hasBtnPermission('detail_manage_del')" command="setEntryAuto">
              {{ detail.entry_auto ? "关闭词条关联" : "开启词条关联" }}
            </el-dropdown-item>
            <el-dropdown-item v-if="loginUser.is_super && detail.type == 8" command="setImportantQB">
              {{ detail.important_at ? "取消重要情报" : "设为重要情报" }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="hasBtnPermission('detail_manage_del')"
              command="onDelArticle"
              style="color: orangered;"
              @click="onDelArticle"
            >
              删除文章
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>
    <!-- 更换绑定文章 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="showBindDialog"
      :width="device.desktop ? '400px' : '90%'"
      append-to-body
      center
      title="更换绑定文章"
    >
      <el-input v-model="bindUrl" placehalder="需要绑定的文章地址（请输入带http或https开头的地址）"></el-input>
      <div class="H10px"></div>
      <el-button class="W100" type="primary" @click="onBindContent">
        确定
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
// api
import {
  apiContentBind,
  apiContentDelete,
  apiContentTop,
  apiContentIgnoreHot,
  apiRollBack,
  apiContentStrategy,
  apiContentDisableComments,
  apiSetEntryAuto,
  apiSetImportantQB
} from "@/api/contentApi";
import { apiContentUpdateAuthor } from "@/api/userApi";
// plugins
import { getJumpWikiDetailUrl, getArticleEditorRoute } from "../../../../plugins/util";

export default {
  name: "DetailDesc",
  components: {},
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      logList: [],
      logPagination: {
        limit: 10,
        page_no: 1,
        page_total: 1,
        total: 0
      },
      bindUrl: "",
      showBindDialog: false
    };
  },
  computed: {
    ...mapGetters(["loginUser", "loginUid", "device", "gameInfo"]),
    // 是否可以回滚
    canRollback() {
      return (
        this.$route.params &&
        this.$route.params.id &&
        this.$route.params.id.includes("_") &&
        this.$hasPermission("content_log_rollback")
      );
    }
  },
  methods: {
    formatTime(time) {
      const now = dayjs();
      const dateTime = dayjs.unix(time);
      if (now.diff(dateTime, "day") > 8) {
        return dateTime.format("YYYY年MM月DD日");
      } else if (now.diff(dateTime, "day") >= 1) {
        return now.diff(dateTime, "day") + "天前";
      } else if (now.diff(dateTime, "hour") >= 1) {
        return now.diff(dateTime, "hour") + "小时前";
      } else if (now.diff(dateTime, "minute") >= 1) {
        return now.diff(dateTime, "minute") + "分钟前";
      } else {
        return "刚刚更新";
      }
    },
    formatCount(count) {
      if (count > 100000000) {
        const num = count / 100000000;
        if (num == (count / 100000000).toFixed(1)) {
          return num + "亿";
        } else {
          return (count / 100000000).toFixed(1) + "亿+";
        }
      } else if (count >= 10000) {
        const num = count / 10000;
        if (num == (count / 10000).toFixed(1)) {
          return num + "W";
        } else {
          return (count / 10000).toFixed(1) + "W+";
        }
      } else if (count >= 1000) {
        const num = count / 1000;
        if (num == (count / 1000).toFixed(1)) {
          return num + "K";
        } else {
          return (count / 1000).toFixed(1) + "K+";
        }
      } else {
        return count;
      }
    },
    // 回滚
    onRollBack() {
      console.log(this.$route.query.logId);
      let { params } = this.$route;
      let id = params.id.split("_")[1];
      apiRollBack({ log_id: Number(id) }).then(res => {
        this.$router.replace(getJumpWikiDetailUrl(this.detail.game.alias, this.detail.game.id, this.detail.id, true));
      });
    },
    // 校验权限
    hasBtnPermission(value, strict = false) {
      let isShow = false;
      if (this.$hasPermission(value, strict)) isShow = true;
      if (this.detail && this.detail.user.uid == this.loginUid) isShow = true;
      return isShow;
    },
    // 操作
    onCommand(command) {
      this[command]();
    },
    // 前往编辑页
    goEdit() {
      const { game, editor_type, id } = this.detail;
      const { alias } = game;
      const route = getArticleEditorRoute(alias, id, editor_type);
      // 标识进入编辑器时详情页编辑，编辑完成后可直接返回详情页
      route.query.isDetailEdit = true;
      this.$router.push(route);
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
    },
    // 删除文章--
    onDelArticle() {
      apiContentDelete({ id: this.detail.id }).then(res => {
        this.$router.go(-1);
      });
    },
    // 设为攻略
    setChangeRaiders() {
      apiContentStrategy({ id: this.detail.id, is_strategy: this.detail.is_strategy ? 0 : 1 }).then(() => {
        this.detail.is_strategy = !this.detail.is_strategy;
      });
    },
    // 更换作者
    onChangeAuthor() {
      this.$prompt("请输入需要更换的用户ID", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+$/,
        inputErrorMessage: "只能输入纯数字"
      })
        .then(({ value }) => {
          let params = {
            id: this.detail.id,
            uid: Number(value)
          };
          apiContentUpdateAuthor(params).then(res => {
            // console.log("res---");
            // console.log(res);
            window.location.reload();
          });
        })
        .catch(() => {});
    },
    // 打开绑定弹框
    onShowBindDialog() {
      this.bindUrl = "";
      this.showBindDialog = true;
    },
    // 换绑词条文章
    onBindContent() {
      let { bindUrl } = this;
      if (!bindUrl) {
        this.$messag("请填写页面地址！");
        return;
      }
      // eslint-disable-next-line
      var reg = new RegExp(/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/);
      if (!reg.test(bindUrl)) {
        this.$messag("请填写正确的网页地址");
        return;
      }
      let params = {
        content_id: this.detail.content_id,
        entry_id: this.detail.entry_id,
        url: bindUrl
      };
      apiContentBind(params).then(res => {
        window.location.href = bindUrl;
        this.showBindDialog = false;
      });
    },
    // 文章置顶
    onContentSetTop() {
      let params = {
        id: this.detail.id
      };
      apiContentTop(params).then(res => {
        this.detail.is_top = this.detail.is_top == 1 ? 0 : 1;
        this.$emit("refresh", this.detail);
      });
    },
    // 下热门
    onDownHot() {
      apiContentIgnoreHot({ id: this.detail.id });
    },
    // 禁止、恢复评论
    onDisabledComment() {
      let params = {
        id: this.detail.id,
        type: this.detail.is_prohibit_reply
      };
      apiContentDisableComments(params).then(res => {
        this.detail.is_prohibit_reply = params.type == 1 ? 0 : 1;
        this.$emit("refresh", this.detail);
      });
    },
    // 开启关闭词条关联
    setEntryAuto() {
      let params = {
        id: this.detail.id,
        entry_auto: this.detail.entry_auto === 1 ? 0 : 1
      };
      apiSetEntryAuto(params).then(res => {
        this.detail.entry_auto = params.entry_auto;
        window.location.reload();
      });
    },
    // 设置为重要情报
    setImportantQB() {
      let params = {
        id: this.detail.id,
        is_important: this.detail.important_at == 0
      };
      apiSetImportantQB(params).then(res => {
        this.detail.important_at = 1;
        window.location.reload();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.wiki-detail-desc {
  border-radius: 4px;
  margin-bottom: 16px;
  color: #666666;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  user-select: none;
  .desc-box {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 90px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 18px;
  }

  .right-drop-btn {
    position: relative;
    margin-right: 28px;
    cursor: pointer;
    color: #2978f7;
    font-size: 12px;
  }
}
.log-btn {
  margin-right: 28px;
  color: #2978f7;
  cursor: pointer;
}

.log-list {
  .item {
    display: flex;
    padding: 8px;
    background-color: #f5f5f5;

    & + .item {
      margin-top: 5px;
    }

    img {
      width: 36px;
      height: 36px;
      border-radius: 18px;
      object-fit: cover;
    }

    .r-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 12px;

      .user-name {
        color: #171717;
        font-weight: 400;
        margin-bottom: 2px;
        font-size: 14px;
      }

      .version {
        color: #666666;
        font-size: 12px;
      }
    }
  }
}
</style>
